export const scanningMediaInsuranceClaimsReadinessProviderId = 'scanning-media.server.insurance-claims-readiness';
//# sourceMappingURL=scanning-media-insurance-claims-readiness.contract.js.map